<search class="e-form-field e-form-field--full-width">
  <div #origin class="e-input e-color-background-1" [class.e-input---loading]="isLoading()">
    <e-icon name="searchColor" />
    <input
      #combobox="ngCombobox"
      ngCombobox
      aria-label="Søk på adresse"
      type="search"
      placeholder="Søk på adresse"
      [formField]="form.term"
      [(expanded)]="popupExpanded"
      (focus)="resetInfoContainer()"
      (input)="onTermInput()"
      (click)="popupExpanded.set(true)"
      autocomplete="off" />
    <button
      type="button"
      class="e-btn e-btn--icon"
      [class.e-none]="!form.term().value()"
      aria-label="Tøm søkefelt"
      (mousedown)="$event.preventDefault()"
      (click)="clear()">
      <span class="e-btn__icon">
        <e-icon name="close" />
      </span>
    </button>
  </div>

  <ng-template
    [cdkConnectedOverlay]="{ origin, usePopover: 'inline', matchWidth: true }"
    [cdkConnectedOverlayOpen]="popupExpanded()">
    <ng-template ngComboboxPopup [combobox]="combobox">
      <div class="search__suggestions floating-box e-color-background-1" [hidden]="!resultsReady()">
        @if (hasError()) {
          <div class="search__message">
            <e-icon name="warningTriangle" size="xs" />
            <p>Det oppstod en feil under søket. Prøv igjen.</p>
          </div>
        } @else if (suggestions().length === 0) {
          <div class="search__message">
            <e-icon name="warningTriangle" size="xs" />
            <p>Vi fant ingen adresser på dette søket <span aria-hidden="true">🤔</span></p>
          </div>
        }
        <div
          #listbox="ngListbox"
          ngListbox
          ngComboboxWidget
          class="list"
          focusMode="activedescendant"
          selectionMode="explicit"
          [tabindex]="-1"
          [activeDescendant]="listbox.activeDescendant()"
          [(value)]="selectedSuggestions"
          (click)="onCommit()"
          (keydown.enter)="onCommit()">
          @for (suggestion of suggestions(); track suggestion.key) {
            <div
              class="list__button search__option"
              ngOption
              [value]="suggestion"
              [label]="suggestion.text ?? ''">
              <span
                class="list__label e-text-interactive-md"
                [innerHTML]="suggestion.text ?? '' | highlightSearch: form.term().value()">
              </span>
              <div class="list__icon">
                <e-icon name="arrowRightCircleColor" size="sm" />
                <e-icon name="arrowRightCircleFilledColor" size="sm" />
              </div>
            </div>
          }
        </div>
      </div>
    </ng-template>
  </ng-template>
</search>

<arcgis-search
  #arcgisSearch
  class="e-none"
  location-disabled
  max-suggestions="5"
  min-suggest-characters="0"
  popup-disabled
  reference-element="map"
  include-default-sources-disabled
  [sources]="sources" />
